let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g9fvd")).then(() => parcelRequire('keyh3'));